import { LockVendor } from './config';

export const transformParamsC2PMS = (lockCode, cardInfo) => {
  if (lockCode === LockVendor.H21) {
    return { ...cardInfo, serialnumber: cardInfo.serialnumber };
  }
  return { ...cardInfo, serialnumber: cardInfo.cardno };
};
